import { Component, Input, OnInit } from '@angular/core';
import { NavigationItem } from '../../models/navigation-item.model';

@Component({
  selector: 'app-menus-nav-bar',
  templateUrl: './menus-nav-bar.component.html',
  styleUrls: ['./menus-nav-bar.component.scss']
})
export class MenusNavBarComponent implements OnInit {
  @Input() navigationItems: NavigationItem[] = [];

  constructor() { }

  ngOnInit(): void {
  }

}
